import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function QrCodeImage({ value, size }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let huy = false;
    QRCode.toDataURL(value, { width: size, margin: 1 }).then((url) => {
      if (!huy) setSrc(url);
    });
    return () => {
      huy = true;
    };
  }, [value, size]);

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={1}
      p={2}
      bgColor="white"
      borderRadius="md"
    >
      {src ? (
        <MDBox component="img" src={src} alt={`Mã QR ${value}`} width={size} height={size} />
      ) : (
        <MDBox width={size} height={size} />
      )}
      <MDTypography variant="button" fontWeight="bold" color="dark">
        {value}
      </MDTypography>
    </MDBox>
  );
}

QrCodeImage.defaultProps = {
  size: 180,
};

QrCodeImage.propTypes = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default QrCodeImage;
